export default "__VITE_ASSET__DoYkK6gr__"